import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import './index.scss';

interface HtmlContentProps {
  content: string;
  className?: string;
}

const HtmlContent: React.FC<HtmlContentProps> = ({ content, className }) => {
  // Clean up content by replacing consecutive <p><br></p> with a single one
  const cleanContent = content
    ? content.replace(/(<p><br><\/p>){2,}/g, '<p><br></p>')
    : '';

  // Custom transform function for ReactHtmlParser
  const transform = (node: any) => {
    // If it's a paragraph with only a <br> tag, reduce its impact
    if (
      node.type === 'tag' &&
      node.name === 'p' &&
      node.children.length === 1 &&
      node.children[0].name === 'br'
    ) {
      return <span className="reduced-break"></span>;
    }
    return undefined; // Return undefined to use default transform
  };

  return (
    <div className={`html-content ${className || ''}`}>
      {ReactHtmlParser(cleanContent, { transform })}
    </div>
  );
};

export default HtmlContent;
